module.exports = __webpack_public_path__ + "static/water6-032718961fdd406f3842aae89c4eb066.jpg";